import { GroupHeader } from '../types';

export default (item: unknown): item is GroupHeader => {
  return !!(item as GroupHeader).isGroupHeader;
};
